import { isMobile, browserName, browserVersion, osName, osVersion, mobileVendor, mobileModel } from 'react-device-detect';
import { isAuthenticated } from '.';
import { APP_VERSION } from '../services/environments';
import { userProductWiseTimeTrackerService } from '../services/profile';

export const initTimeTracker = (product) => {
  const device = getDeviceInfo();
  if (isAuthenticated()) {
    userProductWiseTimeTrackerService({ product: product, device: device })
      .then((response) => {
        const ttdata = { product: product, trackerId: response.userProductWiseTimeTracker.id };
        localStorage.setItem('ttdata', JSON.stringify(ttdata));
      })
      .catch((error) => console.log('Error ', error));
  }
};

export const finishTimeTracker = (trackerId) => {
  if (isAuthenticated()) {
    userProductWiseTimeTrackerService({ id: trackerId })
      .then((response) => {})
      .catch((error) => console.log('Error ', error));
  }
};

const getDeviceInfo = () => {
  if (isMobile) {
    return `${trimSpace(browserName)}_${browserVersion} ${trimSpace(osName)}_${osVersion} MobileWeb ${mobileVendor}_${mobileModel} cme_v${APP_VERSION}`;
  } else {
    return `${trimSpace(browserName)}_${browserVersion} ${trimSpace(osName)}_${osVersion} Desktop cme_v${APP_VERSION}`;
  }
};

const trimSpace = (str) => {
  return str.replace(/([ ])/g, '');
};
